// no change this order!
module.exports = ['temp0to30', 'temp45to55', 'temp60to65', 'temp70to75'];